// src/utils/i18n.js
export const LANGUAGES = ['ja', 'en']
export const DEFAULT_LANG = 'ja'

/**
 * 言語プレフィックス付きパスを生成
 * @param {string} lang - 'ja' | 'en'
 * @param {string} path - '/' で始まるパス
 * @returns {string} - '/{lang}{path}'
 */
export function langPath(lang, path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `/${lang}${normalizedPath}`
}

/**
 * パスから言語プレフィックスを除去
 * @param {string} pathname - '/{lang}/...'
 * @returns {string} - '/...'
 */
export function stripLangPrefix(pathname) {
  const match = pathname.match(/^\/(ja|en)(\/.*)$/)
  return match ? match[2] : pathname
}

/**
 * 対となる言語のURLを返す
 * @param {string} pathname - '/{lang}/...'
 * @returns {string} - '/{altLang}/...'
 */
export function altLangUrl(pathname) {
  const match = pathname.match(/^\/(ja|en)(\/.*)$/)
  if (!match) return pathname
  const altLang = match[1] === 'ja' ? 'en' : 'ja'
  return `/${altLang}${match[2]}`
}

/**
 * パスから言語コードを取得
 * @param {string} pathname
 * @returns {'ja' | 'en'}
 */
export function getLangFromPath(pathname) {
  const match = pathname.match(/^\/(ja|en)(\/|$)/)
  return match ? match[1] : DEFAULT_LANG
}

/**
 * '{count}記事' のようなテンプレートへ値を差し込む
 * @param {string} template
 * @param {Object} values - { count: 3 }
 * @returns {string}
 */
export function fillText(template, values = {}) {
  // 英語の複数形: テンプレートの {s} は count が 1 のとき空、それ以外は s になる（'{count} post{s}'）
  const withPlural =
    values.count !== undefined && values.s === undefined
      ? { ...values, s: Number(values.count) === 1 ? '' : 's' }
      : values
  return Object.entries(withPlural).reduce(
    (text, [key, value]) => text.split(`{${key}}`).join(String(value)),
    template || ''
  )
}
